import styled from 'styled-components'

export const StyledAuthor = styled.div`
   {
    p {
      margin-block-end: 0;
      margin-block-start: 0;
    }

    a {
      overflow-wrap: break-word;
      word-wrap: break-word; /* IE11用 */
    }

    img {
      height: auto !important;
      max-width: 100% !important;
    }

    figure {
      margin: 1em 0;
    }

    .MuiButtonContained {
      a {
        align-items: center;
        -webkit-appearance: none;
        background-color: #1976d2;
        border: 1px solid rgba(25, 118, 210, 0.5);
        border-radius: 4px;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
          0 1px 5px 0 rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
        color: #ffff;
        cursor: pointer;
        display: inline-flex;
        font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
        font-size: 0.875rem;
        font-weight: bold;
        justify-content: center;
        letter-spacing: 0.02857em;
        line-height: 1.75;
        margin: 8px;
        min-width: 64px;
        outline: 0;
        padding: 6px 16px;
        position: relative;
        -webkit-tap-highlight-color: transparent;
        text-decoration: none;
        text-transform: uppercase;
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
          box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
          border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        user-select: none;
        vertical-align: middle;
      }
    }

    .MuiButtonContained:hover {
      a {
        background-color: rgb(17, 82, 147);
        box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
          0 1px 10px 0 rgba(0, 0, 0, 0.12);
        text-decoration: none;
      }
    }

    .MuiButtonText {
      a {
        align-items: center;
        -webkit-appearance: none;
        background-color: transparent;
        border: 0;
        border-radius: 4px;
        box-sizing: border-box;
        color: #1976d2;
        cursor: pointer;
        display: inline-flex;
        font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
        font-size: 0.875rem;
        font-weight: bold;
        justify-content: center;
        letter-spacing: 0.02857em;
        line-height: 1.75;
        min-width: 64px;
        outline: 0;
        padding: 6px 8px;
        position: relative;
        -webkit-tap-highlight-color: transparent;
        text-decoration: none;
        text-transform: uppercase;
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
          box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
          border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        user-select: none;
        vertical-align: middle;
      }
    }

    .MuiButtonText:hover {
      a {
        background-color: rgba(25, 118, 210, 0.04);
        text-decoration: none;
      }
    }

    .MuiButtonOutlined {
      a {
        align-items: center;
        -webkit-appearance: none;
        background-color: transparent;
        border: 1px solid rgba(25, 118, 210, 0.5);
        border-radius: 4px;
        box-sizing: border-box;
        color: #1976d2;
        cursor: pointer;
        display: inline-flex;
        font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
        font-size: 0.875rem;
        font-weight: bold;
        justify-content: center;
        letter-spacing: 0.02857em;
        line-height: 1.75;
        min-width: 64px;
        outline: 0;
        padding: 5px 15px;
        position: relative;
        -webkit-tap-highlight-color: transparent;
        text-decoration: none;
        text-transform: uppercase;
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
          box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
          border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        user-select: none;
        vertical-align: middle;
      }
    }

    .MuiButtonOutlined:hover {
      a {
        background-color: rgba(25, 118, 210, 0.04);
        border: 1px solid #1976d2;
        text-decoration: none;
      }
    }
  }
`
